import React from 'react';
import { itemHasContent } from '../../../../data/filters/directory/itemHasContent';

import CollectClick from '../../../collect/CollectClick';
import ContainedImage from '../../ContainedImage';
import Link from '../../Link';

const Sponsor = props => {
    const {className = '', eventId, sponsor} = props,
        {id, image_url} = sponsor;

    let url;
    if (itemHasContent(sponsor, 'hyperlink')) {
        url = ['/events', eventId, 'sponsor', id].join('/');
    } else if (sponsor.hyperlink) {
        url = sponsor.hyperlink;
    }

    return (
        <CollectClick objectType="sponsor.carousel" objectId={id}>
            <Link className={['sponsor', className].join(' ')} href={url}>
                <ContainedImage src={image_url} />
            </Link>
        </CollectClick>
    );
};

export default Sponsor;

// export default class Sponsor extends React.Component {
//     render() {
//         let classes = ['sponsor', this.props.className],
//             url;

//         // if (!this.props.description && !this.props.detailsImageUrl && !this.props.location && this.props.hyperlink) {
//         //     url = this.props.hyperlink;
//         // } else {
//         //     url = ['/events', this.props.eventId, 'sponsor', this.props.id].join('/');
//         // }

//         return (
//             <CollectClick objectType="sponsor.carousel" objectId={this.props.id}>
//                 <Link className={classes.join(' ')} href={url}>
//                     <ContainedImage src={this.props.image_url} />
//                 </Link>
//             </CollectClick>
//         );
//     }
// }
